<div style="overflow-x: hidden;">
<mat-card *ngIf="page_flag" style="overflow-x: hidden;">
    <!-- <div class="row">
        <div class="col-12">
            <p class="noc_t">NOC List</p>
        </div>
    </div> -->
    <mat-tab-group mat-stretch-tabs="false" class="over" *ngIf="ctp_flag || draft_man ">

        <mat-tab label="In Process NOC files" *ngIf="ctp_flag || draft_man " style="overflow-x: hidden;"> <br>
            <div *ngIf="list_flag">
                <div class="row">
                    <div class="col-11">
                        <div class="filter d-flex">
                            <i class="fa fa-search search_icon" aria-hidden="true"></i>
                            <input class="input-filter" placeholder="Search by Name, Letter Number"
                                (keyup)="applyFilter($any($event.target).value)">
                        </div>
                    </div>
                    <div class="col-1 text-center">
                        <div class="export_btn mt-1">
                            <button class="btn_export" (click)="export()">Export</button>
                        </div>
                    </div>
                </div>
                <div class="example-container mt-2" style="text-size-adjust: 2;">
                    <table mat-table [dataSource]="datasource" matSort>
                        <ng-container matColumnDef="si_no">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>SI.NO</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.new_index}}</td>
                        </ng-container>
                        <ng-container matColumnDef="applicant_name">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Applicant Name</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.party_name}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="file_number">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>File Number</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.file_number}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="letter_number">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>LDA Letter Number</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.lda_letter_number}}</td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Status</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.life_cycle_status}}</td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Action</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                <button class="btn btn-primary"
                                    *ngIf="ctp_flag && element.life_cycle_status == 'LAST_LEVEL_APPROVED'"
                                    (click)="send_to_draft_man(element)">Send To Draft Man</button>
                                <button class="btn btn-primary"
                                    *ngIf="draft_man && element.life_cycle_status == 'ASSIGN_TO_DRFT_MAN'"
                                    (click)="generate(element)">Generate Bill</button>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator #paginator1 [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
                </div>
            </div>




            <div *ngIf="create_flag">
                <mat-horizontal-stepper [linear]="isLinear" #stepper1>
                    <mat-step [stepControl]="first" label="File Creation" completed="false">
                        <div class="row">
                            <div class="col-12">
                                <div class="div_header mt-3">
                                    <h6 class="text_sty">File Details</h6>
                                    <hr>
                                    <div class="inner_div mt-1">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>Applicant Name :</p>
                                            </div>
                                            <div class="col-md-6 text-right">{{Obj['party_name']}}</div>
                                        </div>
                                        <div class="row ">
                                            <div class="col-md-6">
                                                <p>Applicant Mobile Number :</p>
                                            </div>
                                            <div class="col-md-6 text-right">{{Obj['party_mobile']}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>LDA Letter Number :</p>
                                            </div>
                                            <div class="col-md-6 text-right">{{Obj['lda_letter_number']}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>Building Type :</p>
                                            </div>
                                            <div class="col-6 text-right">{{Obj['building_type']}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>File Number :</p>
                                            </div>
                                            <div class="col-md-6 text-right">{{Obj['file_number']}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="row mt-2">
                            <div class="col-12 text-center">
                                <button mat-button mat-raised-button class="btn btn-success"
                                    (click)="back()">Back</button> &nbsp;&nbsp;
                                <!--Back-->
                                <button mat-button mat-raised-button class="btn btn-primary"
                                    matStepperNext>Next</button>
                            </div>
                        </div>
                    </mat-step>

                    <mat-step [stepControl]="second" label="Note Sheet">
                        <div class="div_header mt-4">
                            <div class="borderr" *ngFor="let item of notesheet_desc; let i = index">
                                <h6 class="text_sty">{{i+1}}.Notsheet</h6>
                                <!-- <div class="row" *ngFor="let item2 of item.supp_doc; let j = index">
                            <div class="col-12">
                                <h6 class="supp_doc" (click)="view_correspondence(item2.supp_doc_name)">{{j+1}}.{{item2.supp_doc_name}}</h6>
                            </div>
                         </div> -->
                                <hr>
                                <div class="inner_div mt-3">
                                    <div class="notesheet_header font-weight-bold" [innerHTML]="item.desc.header"><br>
                                    </div>
                                    <div class="body" [innerHTML]="item.desc.body"></div>
                                    <div class="footer" [innerHTML]="item.desc.footer"></div>
                                    <div style="color: red;font-size: bold;text-align: right;">
                                        ({{UserObj[item['user_id']]}})
                                    </div>
                                    <!-- <div class="page font-weight-bold">{{i+1}}</div> -->
                                    <!-- <div class="corresondence" style="cursor: pointer;" (click)="viewCorr(item.notesheet_id,item.notesheet_no)">View Correspondence</div> -->

                                </div>
                                <br>
                            </div>
                            <br>
                        </div>

                        <div class="row">
                            <div class="col-12 text-center">
                                <button mat-button mat-raised-button class="btn btn-success"
                                    matStepperPrevious>Back</button> &nbsp;&nbsp;
                                <!--Back-->
                                <button mat-button mat-raised-button class="btn btn-primary"
                                    matStepperNext>Next</button>
                            </div>
                        </div>

                    </mat-step>

                    <mat-step [stepControl]="third" label="Documents">

                        <div class="div div_header">
                            <h6 class="text_sty">Supporting Document</h6>
                            <hr>
                            <div class="row " *ngFor="let item of supp_doc; let i = index">
                                <div class="col-12 text_styy" (click)="view_correspondence(item.supp_doc_name)">{{i+1}}
                                    . {{item.supp_doc_name}}</div>
                                <!-- <div class="col-5">{{item.notesheet_id}}</div>
                           <div class="col-6"></div> -->
                            </div>
                        </div>





                        <div class="row">
                            <div class="col-12 text-center">
                                <button mat-button mat-raised-button class="btn btn-success"
                                    matStepperPrevious>Back</button> &nbsp;&nbsp;
                                <!--Back-->
                                <button mat-button mat-raised-button class="btn btn-primary" *ngIf="ctp_flag"
                                    (click)="send_for_billing()">Send For Billing</button>
                                <button mat-button mat-raised-button class="btn btn-primary" *ngIf="draft_man"
                                    (click)="Draftman()">Generate Bill</button>
                                <button mat-button mat-raised-button class="btn btn-primary"
                                    *ngIf="role == 'CHEIF ENG' " (click)="billdataforchiefeng()">GET Bill</button>
                            </div>
                        </div>

                    </mat-step>




                </mat-horizontal-stepper>
            </div>
        </mat-tab>

        <mat-tab label="Approved NOC File" *ngIf="ctp_flag ">

            <div *ngIf="list_flag">
                <div class="row">
                    <div class="col-11">
                        <div class="filter d-flex">
                            <i class="fa fa-search search_icon" aria-hidden="true"></i>
                            <input class="input-filter" placeholder="Search by Name, Letter Number"
                                (keyup)="applyFilter($any($event.target).value)">
                        </div>
                    </div>
                    <div class="col-1 text-center">
                        <div class="export_btn mt-1">
                            <button class="btn_export" (click)="export_appr_file()">Export</button>
                        </div>
                    </div>
                </div>
                <div class="example-container mt-2" style="text-size-adjust: 2;">
                    <table mat-table [dataSource]="datasource_appr_file" matSort #sortCol3="matSort">
                        <ng-container matColumnDef="si_no">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>SI.NO</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.new_index}}</td>
                        </ng-container>
                        <ng-container matColumnDef="applicant_name">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Applicant Name</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.party_name}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="file_number">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>File Number</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.file_number}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="letter_number">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>LDA Letter Number</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.lda_letter_number}}</td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Status</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.life_cycle_status}}</td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Action</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                <button class="btn btn-outline-primary"
                                    *ngIf="ctp_flag && element.life_cycle_status == 'LAST_LEVEL_APPROVED'"
                                    (click)="send_to_draft_man(element)">Send To Draft Man</button>
                                <button class="btn btn-outline-primary"
                                    *ngIf="draft_man && element.life_cycle_status == 'ASSIGN_TO_DRFT_MAN'"
                                    (click)="generate(element)">Generate Bill</button>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator #paginator3 [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
                </div>
            </div>





        </mat-tab>
        <mat-tab label="Generated Bills" *ngIf="ctp_flag || draft_man ">
            <div class="row ">
                <div class="col-11">
                    <div class="filter d-flex">
                        <i class="fa fa-search search_icon" aria-hidden="true"></i>
                        <input class="input-filter" placeholder="Search by Name, Letter Number"
                            (keyup)="applyFilter($any($event.target).value)">
                    </div>
                </div>
                <div class="col-1 text-center">
                    <div class="export_btn mt-1">
                        <button class="btn_export" (click)="export1()">Export</button>
                    </div>
                </div>
            </div>
            <div class="example-container mt-2" style="text-size-adjust: 2;">
                <table mat-table [dataSource]="datasource1" matSort #sortCol4="matSort">

                    <ng-container matColumnDef="si_no">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                            SI.NO
                        </th>
                        <td mat-cell flex-stretch *matCellDef="let element;let i = index " class="right">
                            {{i+1}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="applicant_name">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                            Applicant Name
                        </th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                            {{element.party_name}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="file_number">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                            File Number
                        </th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                            {{element.file_number}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="bill_id">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                            Bill ID
                        </th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                            {{element.bill_sh_id}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="letter_number">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                            LDA Letter Number
                        </th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                            {{element.lda_letter_number}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="status">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                            Status
                        </th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                            {{element.life_cycle_status}}
                        </td>
                    </ng-container>



                    <ng-container matColumnDef="action" style="width: 5%;">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>
                            Action</th>
                        <!--Action-->
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">

                            <button class="btn btn-primary" (click)="print(element,'pdf')">Print</button>


                        </td>

                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="displayedColumns1"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns1;">
                    </tr>
                </table>
                <mat-paginator #paginator4 [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>

            </div>











        </mat-tab>
        <mat-tab label="Approved Bills" *ngIf="ctp_flag">

            <div *ngIf="list_flag">
                <div class="row">
                    <div class="col-11">
                        <div class="filter d-flex">
                            <i class="fa fa-search search_icon" aria-hidden="true"></i>
                            <input class="input-filter" placeholder="Search by Name, Letter Number"
                                (keyup)="applyFilter($any($event.target).value)">
                        </div>
                    </div>
                    <div class="col-1 text-center">
                        <div class="export_btn mt-1">
                            <button class="btn_export" (click)="export_bill_pay()">Export</button>
                        </div>
                    </div>
                </div>
                <div class="example-container mt-2" style="text-size-adjust: 2;">
                    <table mat-table [dataSource]="billpay_datasource" matSort #sortCol5="matSort">
                        <ng-container matColumnDef="si_no">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>SI.NO</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.new_index}}</td>
                        </ng-container>
                        <ng-container matColumnDef="applicant_name">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Applicant Name</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.party_name}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="file_number">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>File Number</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.file_number}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="letter_number">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>LDA Letter Number</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.lda_letter_number}}</td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Status</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.life_cycle_status}}</td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Action</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">

                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator #paginator9 [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
                </div>
            </div>

        </mat-tab>
        <mat-tab label="Verify NOC Payment" *ngIf="ctp_flag">
            <div *ngIf="list_flag">
                <div class="row">
                    <div class="col-11">
                        <div class="filter d-flex">
                            <i class="fa fa-search search_icon" aria-hidden="true"></i>
                            <input class="input-filter" placeholder="Search by Name, Letter Number"
                                (keyup)="applyFilter($any($event.target).value)">
                        </div>
                    </div>
                    <div class="col-1 text-center">
                        <div class="export_btn mt-1">
                            <button class="btn_export" (click)="export_verify()">Export</button>
                        </div>
                    </div>
                </div>
                <div class="example-container mt-2" style="text-size-adjust: 2;">
                    <table mat-table [dataSource]="verifyed_datasource" matSort #sortCol5="matSort">
                        <ng-container matColumnDef="si_no">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>SI.NO</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.new_index}}</td>
                        </ng-container>
                        <ng-container matColumnDef="applicant_name">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Applicant Name</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.party_name}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="file_number">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>File Number</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.file_number}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="letter_number">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>LDA Letter Number</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.lda_letter_number}}</td>
                        </ng-container>
                        <ng-container matColumnDef="status">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Status</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.life_cycle_status}}</td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Action</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">

                                <button class="btn btn-outline-primary"
                                    *ngIf="ctp_flag && element.life_cycle_status == 'VERIFYED'"
                                    (click)="nocgeneration(element)">NOC Generation</button>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                    </table>
                    <mat-paginator #paginator5 [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    <mat-tab-group mat-stretch-tabs="false" class="over" *ngIf="amc_flag || chief_eng ">
        <mat-tab label="Approved NOC ">
            <div>
                <div *ngIf="list_flag">

                    <div class="row">
                        <div class="col-11">
                            <div class="filter d-flex">
                                <i class="fa fa-search search_icon" aria-hidden="true"></i>
                                <input class="input-filter" placeholder="Search by Name, Letter Number"
                                    (keyup)="applyFilterchfeng($any($event.target).value)">
                            </div>
                        </div>
                        <div class="col-1 text-center">
                            <div class="export_btn mt-1">
                                <button class="btn_export" (click)="exportchiefengapp()">Export</button>
                            </div>
                        </div>
                    </div>
                    <div class="example-container mt-2" style="text-size-adjust: 2;">
                        <table mat-table [dataSource]="datasource_chief_eng_approved" matSort #sortCol6="matSort">
                            <ng-container matColumnDef="si_no">
                                <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>SI.NO</th>
                                <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.new_index}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="applicant_name">
                                <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Applicant Name</th>
                                <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.party_name}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="file_number">
                                <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>File Number</th>
                                <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                    {{element.file_number}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="letter_number">
                                <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>LDA Letter Number
                                </th>
                                <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                    {{element.lda_letter_number}}</td>
                            </ng-container>
                            <ng-container matColumnDef="Date">
                                <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>DATE</th>
                                <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.bill_date |
                                    date: 'dd/MM/yyyy'}}</td>
                            </ng-container>
                            <ng-container matColumnDef="Property_Size">
                                <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Total Area</th>
                                <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.total_area}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="Bill_Amount">
                                <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Bill Amount </th>
                                <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                    ₹ {{element.bill_amount}}
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="Preview">
                                <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Preview</th>
                                <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                    <h6 class="btn-link" *ngIf="amc_flag || chief_eng" (click)="print(element,'view')">View Bill</h6>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Action</th>
                                <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                    <!-- <button class="btn btn-primary"
                                        *ngIf="chief_eng || amc_flag && element.status != 'APPROVED'"
                                        (click)="generate(element)">Generate Bill</button>
                                    <button class="btn btn-primary"
                                        *ngIf="chief_eng || amc_flag && element.status != 'APPROVED'"
                                        (click)="reject(element)">Remark </button> -->
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns_chief_eng"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns_chief_eng;"></tr>
                        </table>
                        <mat-paginator #paginator6 [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
                    </div>
                </div>
                <div *ngIf="create_flag">
                    <mat-horizontal-stepper [linear]="isLinear" #stepper1>
                        <mat-step [stepControl]="first" label="File Creation" completed="false">
                            <div class="row">
                                <div class="col-12">
                                    <div class="div_header mt-3">
                                        <h6 class="text_sty">File Details</h6>
                                        <hr>
                                        <div class="inner_div mt-1">
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <p>Applicant Name :</p>
                                                </div>
                                                <div class="col-md-6 text-right">{{Obj['party_name']}}</div>
                                            </div>
                                            <div class="row ">
                                                <div class="col-md-6">
                                                    <p>Applicant Mobile Number :</p>
                                                </div>
                                                <div class="col-md-6 text-right">{{Obj['party_mobile']}}</div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <p>LDA Letter Number :</p>
                                                </div>
                                                <div class="col-md-6 text-right">{{Obj['lda_letter_number']}}</div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <p>Building Type :</p>
                                                </div>
                                                <div class="col-6 text-right">{{Obj['building_type']}}</div>
                                            </div>
                                            <div class="row">
                                                <div class="col-md-6">
                                                    <p>File Number :</p>
                                                </div>
                                                <div class="col-md-6 text-right">{{Obj['file_number']}}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div class="row mt-2">
                                <div class="col-12 text-center">
                                    <button mat-button mat-raised-button class="btn btn-success"
                                        (click)="back()">Back</button> &nbsp;&nbsp;
                                    <!--Back-->
                                    <button mat-button mat-raised-button class="btn btn-primary"
                                        matStepperNext>Next</button>
                                </div>
                            </div>
                        </mat-step>

                        <mat-step [stepControl]="second" label="Note Sheet">
                            <div class="div_header mt-4">
                                <div class="borderr" *ngFor="let item of notesheet_desc; let i = index">
                                    <h6 class="text_sty">{{i+1}}.Notsheet</h6>
                                    <!-- <div class="row" *ngFor="let item2 of item.supp_doc; let j = index">
                                <div class="col-12">
                                    <h6 class="supp_doc" (click)="view_correspondence(item2.supp_doc_name)">{{j+1}}.{{item2.supp_doc_name}}</h6>
                                </div>
                             </div> -->
                                    <hr>
                                    <div class="inner_div mt-3">
                                        <div class="notesheet_header font-weight-bold" [innerHTML]="item.desc.header">
                                            <br>
                                        </div>
                                        <div class="body" [innerHTML]="item.desc.body"></div>
                                        <div class="footer" [innerHTML]="item.desc.footer"></div>
                                        <!-- <div class="page font-weight-bold">{{i+1}}</div> -->
                                        <!-- <div class="corresondence" style="cursor: pointer;" (click)="viewCorr(item.notesheet_id,item.notesheet_no)">View Correspondence</div> -->

                                    </div>
                                    <br>
                                </div>
                                <br>
                            </div>

                            <div class="row">
                                <div class="col-12 text-center">
                                    <button mat-button mat-raised-button class="btn btn-success"
                                        matStepperPrevious>Back</button> &nbsp;&nbsp;
                                    <!--Back-->
                                    <button mat-button mat-raised-button class="btn btn-primary"
                                        matStepperNext>Next</button>
                                </div>
                            </div>

                        </mat-step>

                        <mat-step [stepControl]="third" label="Documents">

                            <div class="div div_header">
                                <h6 class="text_sty">Supporting Document</h6>
                                <hr>
                                <div class="row " *ngFor="let item of supp_doc; let i = index">
                                    <div class="col-12 text_styy" (click)="view_correspondence(item.supp_doc_name)">
                                        {{i+1}}
                                        . {{item.supp_doc_name}}</div>
                                    <!-- <div class="col-5">{{item.notesheet_id}}</div>
                               <div class="col-6"></div> -->
                                </div>
                            </div>





                            <div class="row">
                                <div class="col-12 text-center">
                                    <button mat-button mat-raised-button class="btn btn-success"
                                        matStepperPrevious>Back</button> &nbsp;&nbsp;
                                    <!--Back-->
                                    <button mat-button mat-raised-button class="btn btn-primary" *ngIf="ctp_flag"
                                        (click)="send_for_billing()">Send For Billing</button>
                                    <button mat-button mat-raised-button class="btn btn-primary" *ngIf="draft_man"
                                        (click)="Draftman()">Generate Bill</button>
                                    <button mat-button mat-raised-button class="btn btn-primary"
                                        *ngIf="amc_flag ||  role == 'CHEIF ENG' " (click)="billdataforchiefeng()">GET
                                        Bill</button>
                                </div>
                            </div>

                        </mat-step>




                    </mat-horizontal-stepper>
                </div>
            </div>
        </mat-tab>

        <mat-tab label="Generated Bills">

            <div *ngIf="list_flag">

                <div class="row">
                    <div class="col-11">
                        <div class="filter d-flex">
                            <i class="fa fa-search search_icon" aria-hidden="true"></i>
                            <input class="input-filter" placeholder="Search by Name, Letter Number"
                                (keyup)="applyFilterchfeng($any($event.target).value)">
                        </div>
                    </div>
                    <div class="col-1 text-center">
                        <div class="export_btn mt-1">
                            <button class="btn_export" (click)="exportchiefeng()">Export</button>
                        </div>
                    </div>
                </div>
                <div class="example-container mt-2" style="text-size-adjust: 2;">
                    <table mat-table [dataSource]="datasource_chief_eng" matSort #sortCol7="matSort">
                        <ng-container matColumnDef="si_no">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>SI.NO</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.new_index}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="applicant_name">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Applicant Name</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.party_name}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="file_number">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>File Number</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.file_number}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="letter_number">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>LDA Letter Number
                            </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                {{element.lda_letter_number}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Date">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>DATE</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.bill_date |
                                date: 'dd/MM/yyyy'}}</td>
                        </ng-container>
                        <ng-container matColumnDef="Property_Size">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Total Area</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.total_area}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Bill_Amount">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Bill Amount </th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                ₹ {{element.bill_amount}}
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="Preview">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Preview</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                <h6 class=" btn-link" *ngIf="amc_flag || chief_eng" (click)="print(element,'view')">View Bill</h6>
                            </td>
                        </ng-container>
                        <ng-container matColumnDef="action">
                            <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Action</th>
                            <td mat-cell flex-stretch *matCellDef="let element" class="right">
                                <button class="btn btn-primary"
                                    *ngIf="chief_eng  && (element.fd_status == 'ASSIGN_TO_CHEIF ENG') "
                                    (click)="generate(element)">Generate Bill</button>
                                    <button class="btn btn-primary"
                                    *ngIf="amc_flag && element.fd_status == 'ASSIGN_AMC' "
                                    (click)="generate(element)">Generate Bill</button>
                                <button class="btn btn-primary"
                                    *ngIf="(chief_eng || amc_flag) && element.status != 'APPROVED'"
                                    (click)="reject(element)">Remark </button>
                            </td>
                        </ng-container>
                        <tr mat-header-row *matHeaderRowDef="displayedColumns_chief_eng"></tr>
                        <tr mat-row *matRowDef="let row; columns: displayedColumns_chief_eng;"></tr>
                    </table>
                    <mat-paginator #paginator7 [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
                </div>
            </div>

            <div *ngIf="create_flag">

                <mat-horizontal-stepper [linear]="isLinear" #stepper1>
                    <mat-step [stepControl]="first" label="File Creation" completed="false">
                        <div class="row">
                            <div class="col-12">
                                <div class="div_header mt-3">
                                    <h6 class="text_sty">File Details</h6>
                                    <hr>
                                    <div class="inner_div mt-1">
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>Applicant Name :</p>
                                            </div>
                                            <div class="col-md-6 text-right">{{Obj['party_name']}}</div>
                                        </div>
                                        <div class="row ">
                                            <div class="col-md-6">
                                                <p>Applicant Mobile Number :</p>
                                            </div>
                                            <div class="col-md-6 text-right">{{Obj['party_mobile']}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>LDA Letter Number :</p>
                                            </div>
                                            <div class="col-md-6 text-right">{{Obj['lda_letter_number']}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>Building Type :</p>
                                            </div>
                                            <div class="col-6 text-right">{{Obj['building_type']}}</div>
                                        </div>
                                        <div class="row">
                                            <div class="col-md-6">
                                                <p>File Number :</p>
                                            </div>
                                            <div class="col-md-6 text-right">{{Obj['file_number']}}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>


                        <div class="row mt-2">
                            <div class="col-12 text-center">
                                <button mat-button mat-raised-button class="btn btn-success"
                                    (click)="back()">Back</button> &nbsp;&nbsp;
                                <!--Back-->
                                <button mat-button mat-raised-button class="btn btn-primary"
                                    matStepperNext>Next</button>
                            </div>
                        </div>
                    </mat-step>

                    <mat-step [stepControl]="second" label="Note Sheet">
                        <div class="div_header mt-4">
                            <div class="borderr" *ngFor="let item of notesheet_desc; let i = index">
                                <h6 class="text_sty">{{i+1}}.Notsheet</h6>
                                <!-- <div class="row" *ngFor="let item2 of item.supp_doc; let j = index">
                            <div class="col-12">
                                <h6 class="supp_doc" (click)="view_correspondence(item2.supp_doc_name)">{{j+1}}.{{item2.supp_doc_name}}</h6>
                            </div>
                         </div> -->
                                <hr>
                                <div class="inner_div mt-3">
                                    <div class="notesheet_header font-weight-bold" [innerHTML]="item.desc.header"><br>
                                    </div>
                                    <div class="body" [innerHTML]="item.desc.body"></div>
                                    <div class="footer" [innerHTML]="item.desc.footer"></div>

                                    <!-- <div class="page font-weight-bold">{{i+1}}</div> -->
                                    <!-- <div class="corresondence" style="cursor: pointer;" (click)="viewCorr(item.notesheet_id,item.notesheet_no)">View Correspondence</div> -->
                                    <div style="color: red;font-size: bold;text-align: right;">
                                        ({{UserObj[item['user_id']]}})
                                    </div>
                                </div>

                                <br>
                            </div>
                            <br>
                        </div>

                        <div class="row">
                            <div class="col-12 text-center">
                                <button mat-button mat-raised-button class="btn btn-success"
                                    matStepperPrevious>Back</button> &nbsp;&nbsp;
                                <!--Back-->
                                <button mat-button mat-raised-button class="btn btn-primary"
                                    matStepperNext>Next</button>
                            </div>
                        </div>

                    </mat-step>

                    <mat-step [stepControl]="third" label="Documents">

                        <div class="div div_header">
                            <h6 class="text_sty">Supporting Document</h6>
                            <hr>
                            <div class="row " *ngFor="let item of supp_doc; let i = index">
                                <div class="col-12 text_styy" (click)="view_correspondence(item.supp_doc_name)">{{i+1}}
                                    . {{item.supp_doc_name}}</div>
                                <!-- <div class="col-5">{{item.notesheet_id}}</div>
                           <div class="col-6"></div> -->
                            </div>
                        </div>





                        <div class="row">
                            <div class="col-12 text-center">
                                <button mat-button mat-raised-button class="btn btn-success"
                                    matStepperPrevious>Back</button> &nbsp;&nbsp;
                                <!--Back-->
                                <button mat-button mat-raised-button class="btn btn-primary" *ngIf="ctp_flag"
                                    (click)="send_for_billing()">Send For Billing</button>
                                <button mat-button mat-raised-button class="btn btn-primary" *ngIf="draft_man"
                                    (click)="Draftman()">Generate Bill</button>
                                <button mat-button mat-raised-button class="btn btn-primary"
                                    *ngIf="role == 'CHEIF ENG' " (click)="billdataforchiefeng()">GET Bill</button>
                                <button mat-button mat-raised-button class="btn btn-primary" *ngIf="amc_flag"
                                    (click)="billdataforchiefeng()">GET Bill</button>
                            </div>
                        </div>

                    </mat-step>




                </mat-horizontal-stepper>

            </div>









        </mat-tab>
        <mat-tab label="Bills Remark">

            <div class="row">
                <div class="col-11">
                    <div class="filter d-flex">
                        <i class="fa fa-search search_icon" aria-hidden="true"></i>
                        <input class="input-filter" placeholder="Search by Name, Letter Number"
                            (keyup)="applyFilterchfeng($any($event.target).value)">
                    </div>
                </div>
                <div class="col-1 text-center">
                    <div class="export_btn mt-1">
                        <button class="btn_export" (click)="exportrejectedbill()">Export</button>
                    </div>
                </div>
            </div>
            <div class="example-container mt-2" style="text-size-adjust: 2;">
                <table mat-table [dataSource]="datasource_bill_reject" matSort>
                    <ng-container matColumnDef="si_no">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>SI.NO</th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.new_index}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="applicant_name">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Applicant Name</th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.party_name}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="file_number">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>File Number</th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                            {{element.file_number}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="letter_number">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>LDA Letter Number
                        </th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                            {{element.lda_letter_number}}</td>
                    </ng-container>
                    <ng-container matColumnDef="Date">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>DATE</th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.bill_date |
                            date: 'dd/MM/yyyy'}}</td>
                    </ng-container>
                    <ng-container matColumnDef="Property_Size">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Total Area</th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">{{element.total_area}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Bill_Amount">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Bill Amount </th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                            ₹ {{element.bill_amount}}
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="Preview">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Preview</th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                            <!-- <button class="btn btn-primary" *ngIf="chief_eng" (click)="generate(element)">Generate Bill</button> -->
                        </td>
                    </ng-container>
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="right" mat-sort-header>Action</th>
                        <td mat-cell flex-stretch *matCellDef="let element" class="right">
                            <!-- <button class="btn btn-primary"
                                *ngIf="chief_eng || amc_flag && element.status != 'APPROVED'"
                                (click)="generate(element)">Generate Bill</button>
                            <button class="btn btn-primary"
                                *ngIf="chief_eng || amc_flag && element.status != 'APPROVED'"
                                (click)="reject(element)">Remark </button> -->
                        </td>
                    </ng-container>
                    <tr mat-header-row *matHeaderRowDef="displayedColumns_chief_eng"></tr>
                    <tr mat-row *matRowDef="let row; columns: displayedColumns_chief_eng;"></tr>
                </table>
                <mat-paginator  #paginator8 [pageSizeOptions]="[10, 20]" showFirstLastButtons></mat-paginator>
            </div>
        </mat-tab>

    </mat-tab-group>
</mat-card>
</div>
<div *ngIf="bill_flag" style="overflow-x: hidden;">
    <app-noc-bill></app-noc-bill>
    <mat-card>
        <div class="row">
            <div class="col-12 text-right">
                <button class="bck" (click)="back_dft()">Back</button>
                <button class="AMC" *ngIf="draft_man" (click)="send_for_billing()">Send To Chief Eng</button>
                <button class="AMC" *ngIf="chief_eng" (click)="send_for_billing()">Approve & sent to AMC</button>
                <button class="AMC" *ngIf="amc_flag" (click)="send_for_billing()">Approve & sent to Customer</button>
                <!-- <button class="AMC" (click)="submit()">Generate To AMC</button> -->
            </div>
        </div>
    </mat-card>
</div>


<!-- <div *ngIf="chief_eng">
    <app-noc-bill></app-noc-bill>
    <mat-card>
        <div class="row">
            <div class="col-12 text-right">
                <button class="bck" (click)="back_dft()">Back</button>
                <button class="AMC" (click)="send_for_billing()">Generate To AMC</button>


            </div>
        </div>
    </mat-card>
</div> -->


<!-- /////////work flow start//////// -->
<!-- WORKFLOW MODEL -->
<div class="modal" id="myModal3">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Approval</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">

                <div class="row"
                    *ngIf="ApprovalUserService.vendorflag==false && ApprovalUserService.approvalflag==false">
                    <div class="col-4 text-right">
                        <h6>Select Forwarded To :</h6>
                    </div>
                    <div class="col-4">
                        <ng-select [items]="ApprovalUserService.workuser" bindLabel="desc" bindValue="user_id_appr"
                            [multiple]="false" placeholder="Select User" [(ngModel)]="forwarded_user_id"
                            [selectableGroup]="true" [selectableGroupAsModel]="false" [closeOnSelect]="true"
                            name="work_order_id">
                        </ng-select>
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-4 text-right">
                        <h6>Remark :</h6>
                    </div>
                    <div class="col-4">
                        <textarea style="width: 100%; height: 80px;" id="re" name="re" [(ngModel)]="appr_remark"
                            placeholder="Enter Your Remark" class="form-control"></textarea>
                    </div>
                </div>
                <br>

                <div>
                    <table class="table table-bordered"
                        style="width: 90%; margin-left: 5%;overflow-x:scroll;scroll-margin-block: 1; ">
                        <thead>
                            <tr style="background-color:  white;">
                                <th style="width: 20%;">S No.</th>
                                <th style="width: 20%;">Decription</th>
                                <th style="width: 60%;">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let ln of undertakings;let i = index">
                                <td>{{i+1}}</td>
                                <td>{{ln['desc']}}</td>
                                <td style="width: 60%;">
                                    <input type="checkbox" [(ngModel)]="ln['check']" style="color: green;">

                                </td>
                            </tr>

                        </tbody>

                    </table>
                </div>
                <br>
                <div class="row" style="border: black;">
                    <div class="col-4 text-right">
                        <input type="checkbox" [(ngModel)]="message_flag" id="vehicle1" name="vehicle1" value="Bike">
                    </div>
                    <div class="col-4">
                        Notify Them
                    </div>
                </div>
                <br>
                <div class="row"
                    *ngIf="ApprovalUserService.vendorflag==false && ApprovalUserService.approvalflag==false">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" data-dismiss="modal" *ngIf="draft_man" (click)="submit()">Submit
                        </button>
                        <button class="btn btn-primary" data-dismiss="modal" *ngIf="chief_eng || ctp_flag || amc_flag"
                            (click)="Approvedapproval()">Submit
                        </button>
                    </div>
                </div>
                <div class="row"
                    *ngIf="ApprovalUserService.vendorflag==false && ApprovalUserService.approvalflag==true">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" data-dismiss="modal" (click)="lastlevelappr()">Approve & sent to
                            Customer
                        </button>
                    </div>
                </div>
                <br>

                <div *ngIf="ApprovalUserService.vendorflag==true" class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" data-dismiss="modal" (click)="Approvedapproval()">Forward To
                            Vendor</button>
                    </div>
                </div>
                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>
</div>

<!-- WORKFLOW MODEL -->
<div class="modal" id="rejected">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">

            <!-- Modal Header -->
            <div class="modal-header">
                <h4 class="modal-title">Rejected</h4>
                <button type="button" class="close" data-dismiss="modal">&times;</button>
            </div>
            <div class="modal-body">



                <!-- New Code for Notesheet -->
                <div class="notesheet">
                    <div class="row">

                        <div class="col-3">
                            <h6> Add Remark <span style="color: red;">*</span> </h6>
                        </div>
                        <!-- <div *ngIf="isRejectButtonActive"> -->
                        <div>

                            <app-editor></app-editor>
                        </div>
                        <!-- <div class="col-3"><label for="Language"> Select Language :</label>

                        </div>
                        <div class="col-3">
                            <ng-select [items]="lang_list" (change)="onChangeLang()" [multiple]="false"
                                placeholder="Select Language" [(ngModel)]="selectedLang" [selectableGroup]="true"
                                [selectableGroupAsModel]="false" [closeOnSelect]="true">
                            </ng-select>

                        </div> -->
                        <div class="col-3">
                            <!-- <label for="Language" *ngIf="hindi_text_flag"> Select Font :</label> -->
                        </div>
                        <div class="col-3">
                            <!-- <ng-select [items]="font_list" (change)="onChangeFont()" [multiple]="false"
                                placeholder="Select Font" [(ngModel)]="selectedFont" [selectableGroup]="true"
                                [selectableGroupAsModel]="false" [closeOnSelect]="true" *ngIf="hindi_text_flag">
                            </ng-select> -->
                        </div>

                    </div>

                    <!-- <div id="text-input" contenteditable="true" (blur)="getAllcontent($event)" #textContent2
                        [class.hindi_text]="hindi_text_flag" style="font-size: 2.2rem">

                    </div> -->
                </div>

                <br>
                <div class="row" style="border: black;">
                    <div class="col-4 text-right">
                        <input type="checkbox" [(ngModel)]="message_flag" id="vehicle1" name="vehicle1" value="Bike">
                    </div>
                    <div class="col-4">
                        Notify Them
                    </div>
                </div>
                <br>
                <div class="row">
                    <div class="col-12 text-center">
                        <button class="btn btn-primary" data-dismiss="modal" (click)="finalreject()">Submit
                        </button>
                    </div>
                </div>
                <br>


                <!-- Modal footer -->
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-dismiss="modal">Close</button>
                </div>

            </div>
        </div>
    </div>
</div>